import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 测量点命令控制
 */
const command = {

  /**
   * 执行指令
   */
  executeCommandOnMeasure (measureId, command, args) {
    return axios.post(base.command.executeCommandOnMeasure, utils.postParamsArrayToJsonString({ measureId, command, args }))
  },
  /**
   * 查询指令执行历史
   */
  getRecentHistoryOfMeasureCommandExecuting (measureId, limit) {
    return axios.post(base.command.getRecentHistoryOfMeasureCommandExecuting, utils.postParamsArrayToJsonString({ measureId, limit }))
  }
}

export default command